module.exports = __webpack_public_path__ + "0de137c77b95b29b11ce212f8d306069.svg";